var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"bg-grey-1",attrs:{"view":"hHh LpR fFf"}},[_c('v-header'),_c('v-drawer'),_c('q-page-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }